export const entities = {
  organization: "Organization",
  facility: "Facility"
};
